import { forceUpdate, h, Host } from "@stencil/core";
import { i18nProvider } from "@trumpf/ux.i18n";
export class ChatItem {
    constructor() {
        this.name = undefined;
        this.date = undefined;
        this.source = undefined;
        this.profilePicture = undefined;
        this.locale = undefined;
    }
    componentWillLoad() {
        // Subscribe to i18nProvider updates and update locale
        this.updateLocale();
        i18nProvider.subscribe(() => {
            this.updateLocale();
            forceUpdate(this);
        });
    }
    updateLocale() {
        const { language } = i18nProvider;
        const defaultRegionMap = {
            en: "en-US",
            de: "de-DE"
        };
        this.locale = defaultRegionMap[language] || `${language}-${language.toUpperCase()}`;
    }
    /**
     * Formats the date using Intl.DateTimeFormat
     */
    formatDate(dateString) {
        try {
            const date = new Date(dateString);
            const formatter = new Intl.DateTimeFormat(this.locale, {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                hour12: false
            });
            return formatter.format(date);
        }
        catch {
            return "Invalid date";
        }
    }
    render() {
        return (h(Host, { key: '5e5f7a88c60c6b3e5b723c3a8e8abf0d7d8ea0fd', role: "listitem" }, h("div", { key: '5ae4339d6f3547cdae9dc23d911bc827bba1090b', id: "chat-item-container" }, this.source === "bot" && (h("div", { key: '010bd0c4ce5b295c81cc4e6e4180d481a6e2d4c1', class: "profile-picture" }, this.profilePicture ? (h("img", { src: this.profilePicture, alt: `${this.name} profile picture` })) : (h("ux-icon", { name: "ai-assistent", "size-s": "35", weight: "normal", fill: "white" })))), h("div", { key: '063d0d300a813cc2f1bf953367dc44333264741c' }, h("div", { key: '4864138caa1cb46f38ce20b807d7e22fc701507f', class: "message-content" }, h("slot", { key: '0dc20d1276fad89abc62ed360f3676cab5c9c092' })), (this.name || this.date) && (h("div", { key: '26f6f1f11d8e31f9e583e8cf884c939f4799b28a', class: `message-meta ${this.source === "user" ? "user-message-footer" : ""}` }, h("ux-copy", { key: 'f0dc677d2b33b932b2dc258a1e8bbe8dd35fe444', class: "chat-name", variant: "tiny" }, [this.name, this.date && this.formatDate(this.date)].filter(Boolean).join(" - "))))))));
    }
    static get is() { return "ux-chat-item"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["chat-item.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["chat-item.css"]
        };
    }
    static get properties() {
        return {
            "name": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [{
                            "name": "required",
                            "text": undefined
                        }],
                    "text": "The name of the user who sent the chat message."
                },
                "attribute": "name",
                "reflect": false
            },
            "date": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The date when the chat message was sent."
                },
                "attribute": "date",
                "reflect": false
            },
            "source": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "\"user\" | \"system\" | \"bot\"",
                    "resolved": "\"bot\" | \"system\" | \"user\"",
                    "references": {}
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Indicates whether the chat message was sent by the current user system or bot"
                },
                "attribute": "source",
                "reflect": true
            },
            "profilePicture": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string | undefined",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "Optional URL for the profile picture. If not provided, the default icon will be shown for bot messages."
                },
                "attribute": "profile-picture",
                "reflect": false
            }
        };
    }
    static get states() {
        return {
            "locale": {}
        };
    }
}
//# sourceMappingURL=chat-item.js.map
